<template>
    <div class="hos-form">
        <div class="sub_title cb"><img src="../../assets/icon/Rectangle2.png" class="mr10 imgb">开放预约科室</div>
        <div class="mt20">
            <div class="flex mt15 sub_title" v-for="item in list" :key="item.deptId">
                <div class="top_level flex0 width15 pt10 deptName fs16">{{item.deptName}}</div>
                <ul class="flex1 flex wrap fs14 fc">
                    <li v-for="a in item.yyghYyksList" :key="a.ksid" class="mr20 pointer pt10 pb10" @click="saveDept(a)">{{a.ksmc}}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
  import {orderTime} from "../../lib/cache/OrderTime";

  export default {
    name: "departmentList",
    props: {
      list: {
        type: Array,
        default: ()=>{
          return []
        }
      },
    },
    data() {
      return {
        id: '1',
      }
    },
    watch: {
      id(newV) {
        this.$emit('input', newV);
      }
    },
    methods:{
      saveDept(a){
        const ot = orderTime.get()
        ot.deptId = a.ksid
        ot.deptName = a.ksmc
        orderTime.set(ot)
        this.$router.push('/main/registration/schedule')
      }
    }
  }
</script>

<style scoped lang="scss">
    @import "../../styles/var";
    .hos-form{
        padding: 10px 20px;
        color: #666666;
        span+span{
            margin-right: 10px;
            cursor: pointer;
        }
    }
    .sub_title{
        padding: 10px 0;
        color: #1E1E1E;
    }
    .bg_pra{
        background-color: $bgPrimaryColor;
    }
    .cb{
        font-weight: bold;
        color: #333333;
    }

    .fc{
        color: #666666;
    }

    .imgb{
        vertical-align: bottom;
    }

    .deptName{
        font-family: PingFangSC-Regular;
        color: #333333;
        letter-spacing: 0;
    }
</style>
